import { render, staticRenderFns } from "./AnimatedForeground.vue?vue&type=template&id=70e75d96&scoped=true&name=animated-foreground&"
import script from "./AnimatedForeground.vue?vue&type=script&lang=js&"
export * from "./AnimatedForeground.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedForeground.vue?vue&type=style&index=0&id=70e75d96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e75d96",
  null
  
)

export default component.exports